// DS: CR17, CMPST05
import React from 'react';
import FolderContent from './_partials/FolderContent';
import FolderPanel from './_partials/FolderPanel';
import ErrorBoundary from '../../../ErrorBoundary';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import s from './ShopFolderThumb.scss';
export var PANEL_HEIGHT = 82;
export var DEFAULT_THUMB_HEIGHT = 337;
var ShopThumb = function (_a) {
    var folder = _a.folder, width = _a.width, _b = _a.height, height = _b === void 0 ? DEFAULT_THUMB_HEIGHT + PANEL_HEIGHT : _b;
    var _c = normalizePremiumFolderData(folder.premiumFolderData), pointPrice = _c.pointPrice, formattedDollarPrice = _c.formattedDollarPrice;
    return (React.createElement("div", { className: s['root'], style: { width: width, height: height } },
        React.createElement(ErrorBoundary, { debugComponent: "ShopFolderThumb" },
            React.createElement(FolderContent, { folder: folder, width: width, height: height - PANEL_HEIGHT }),
            React.createElement(FolderPanel, { folder: folder, price: pointPrice, dollarsCost: formattedDollarPrice }))));
};
ShopThumb.displayName = 'ShopThumbFolder';
export default ShopThumb;
//# sourceMappingURL=ShopFolderThumb.js.map